import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
    selector: '[preventMultipleCalls]'
})
export class PreventMultiApiCallsDirective implements OnInit, OnDestroy {

    @Input('time') throttleTimeValue = 7000
    @Output('emit') fireCallEventEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    clickObserable = new Observable<Event>();
    clickSubscription: Subscription;

    constructor(private elementRef: ElementRef) {
        this.clickObserable = fromEvent(this.elementRef.nativeElement, 'click')
    }

    ngOnInit(): void {
        this.clickSubscription = this.clickObserable.pipe(throttleTime(this.throttleTimeValue))
            .subscribe(event => {
                this.fireCallEventEmitter.emit(true)
            });
    }

    ngOnDestroy(): void {
        this.clickSubscription?.unsubscribe();
    }

}
